import { WINDOW_FEATURES } from './constants';
class Selector {
  async init(_) {
    return this;
  }
  open({ ezProductSelectorUrl }, isWindowFeaturesDisable = false) {
    if (isWindowFeaturesDisable) {
      window.open(ezProductSelectorUrl, '_blank', '');
    }
    else {
      window.open(ezProductSelectorUrl, '_blank', WINDOW_FEATURES);
    }
    return this;
  }
}
export const EzProductSelector = new Selector();
